import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;

import { observable, set, flow, computed, action } from "mobx";
import { locationRestPluginUpdatePatch, locationRestPluginUpdateSkipPost, locationRestAnnouncementActive } from "../wp-api";
import { request } from "../utils";
import { License } from ".";
let PluginUpdate = (_class = class PluginUpdate {
  get licensedEntries() {
    return this.licenses.filter(({
      code
    }) => code);
  }

  get unlicensedEntries() {
    return this.licenses.filter(({
      code
    }) => !code);
  }

  get noUsageEntries() {
    return this.unlicensedEntries.filter(({
      noUsage
    }) => noUsage);
  }

  get modifiableEntries() {
    return this.unlicensedEntries.filter(({
      programmatically
    }) => !programmatically);
  }

  get isLicensed() {
    return this.unlicensedEntries.length === 0;
  }

  constructor(pluginUpdate, store) {
    _initializerDefineProperty(this, "busy", _descriptor, this);

    _initializerDefineProperty(this, "slug", _descriptor2, this);

    _initializerDefineProperty(this, "licenses", _descriptor3, this);

    _initializerDefineProperty(this, "hasInteractedWithFormOnce", _descriptor4, this);

    _initializerDefineProperty(this, "name", _descriptor5, this);

    _initializerDefineProperty(this, "needsLicenseKeys", _descriptor6, this);

    _initializerDefineProperty(this, "announcementsActive", _descriptor7, this);

    _initializerDefineProperty(this, "allowsAutoUpdates", _descriptor8, this);

    _initializerDefineProperty(this, "allowsTelemetry", _descriptor9, this);

    _initializerDefineProperty(this, "allowsNewsletter", _descriptor10, this);

    _initializerDefineProperty(this, "potentialNewsletterUser", _descriptor11, this);

    _initializerDefineProperty(this, "privacyProvider", _descriptor12, this);

    _initializerDefineProperty(this, "privacyPolicy", _descriptor13, this);

    _initializerDefineProperty(this, "accountSiteUrl", _descriptor14, this);

    _initializerDefineProperty(this, "licenseKeyHelpUrl", _descriptor15, this);

    _initializerDefineProperty(this, "checkUpdateLink", _descriptor16, this);

    _initializerDefineProperty(this, "invalidKeysError", _descriptor17, this);

    _initializerDefineProperty(this, "showBlogName", _descriptor18, this);

    _initializerDefineProperty(this, "showNetworkWideUpdateIssueNotice", _descriptor19, this);

    this.store = void 0;
    this.setAnnouncementActive = flow(function* (state) {
      this.busy = true;

      try {
        const result = yield request({
          location: locationRestAnnouncementActive,
          params: {
            slug: this.slug
          },
          request: {
            state
          }
        });

        if (result.success) {
          this.announcementsActive = state;
        }

        return result.success;
      } catch (e) {
        console.log(e);
        throw e;
      } finally {
        this.busy = false;
      }
    });
    this.update = flow(function* (data) {
      this.busy = true;
      this.invalidKeysError = undefined;

      try {
        const result = yield request({
          location: locationRestPluginUpdatePatch,
          params: {
            slug: this.slug
          },
          request: data
        });
        this.fromResponse(result);
      } catch (e) {
        var _e$responseJSON, _e$responseJSON$data;

        console.log(e); // Parse error for invalid keys

        if ((_e$responseJSON = e.responseJSON) !== null && _e$responseJSON !== void 0 && (_e$responseJSON$data = _e$responseJSON.data) !== null && _e$responseJSON$data !== void 0 && _e$responseJSON$data.invalidKeys) {
          this.invalidKeysError = e.responseJSON.data.invalidKeys;
        }

        throw e;
      } finally {
        this.busy = false;
      }
    });
    this.skip = flow(function* () {
      this.busy = true;

      try {
        yield request({
          location: locationRestPluginUpdateSkipPost,
          params: {
            slug: this.slug
          }
        });
      } catch (e) {
        var _e$responseJSON2, _e$responseJSON2$data;

        console.log(e); // Parse error for invalid keys

        if ((_e$responseJSON2 = e.responseJSON) !== null && _e$responseJSON2 !== void 0 && (_e$responseJSON2$data = _e$responseJSON2.data) !== null && _e$responseJSON2$data !== void 0 && _e$responseJSON2$data.invalidKeys) {
          this.invalidKeysError = e.responseJSON.data.invalidKeysError;
        }

        throw e;
      } finally {
        this.busy = false;
      }
    });
    this.fromResponse(pluginUpdate);
    this.store = store;
  }

  fromResponse({
    licenses,
    ...pluginUpdate
  }) {
    set(this, pluginUpdate);
    this.licenses = [];
    licenses === null || licenses === void 0 ? void 0 : licenses.forEach(license => {
      this.licenses.push(new License(license, this));
    });
  } // eslint-disable-next-line @typescript-eslint/member-ordering


}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "slug", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "licenses", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasInteractedWithFormOnce", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "needsLicenseKeys", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "announcementsActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "allowsAutoUpdates", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "allowsTelemetry", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "allowsNewsletter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "potentialNewsletterUser", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "privacyProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "privacyPolicy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "accountSiteUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "licenseKeyHelpUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "checkUpdateLink", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "invalidKeysError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "showBlogName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showNetworkWideUpdateIssueNotice", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "licensedEntries", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "licensedEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unlicensedEntries", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unlicensedEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noUsageEntries", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noUsageEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modifiableEntries", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "modifiableEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLicensed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLicensed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fromResponse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fromResponse"), _class.prototype)), _class);
export { PluginUpdate };